// extracted by css-extract-rspack-plugin
export default {"tab":"tab-Jxeogd","active":"active-K3iX7A"};